import Link from 'next/link';
import SimpleHeader from './simple-header';
import SimpleSignIn from './simple-sign-in';
import SimpleUserProfile from './simple-user-profile';
import { ArrowSmRightIcon } from '@heroicons/react/solid';
import { Button } from '@chakra-ui/react';

type Props = {
  userProfile: string;
  signIn: string;
};

export function Code({ signIn, userProfile }: Props) {
  return (
    <section className="mt-28" id="simple">
      <SimpleHeader />
      <div className="">
        <SimpleSignIn imagePosition="right" signIn={signIn} />
        <SimpleUserProfile imagePosition="right" userProfile={userProfile} />
        <div className="mx-auto mt-5 max-w-md sm:flex sm:justify-center md:mt-8">
          <div className="mx-8 rounded-md">
            <Link
              href="/docs/components/overview"
              target="_blank"
              rel="noopener"
            >
              <Button
                rightIcon={
                  <ArrowSmRightIcon className="ml-1 -mr-1.5 h-6 w-6" />
                }
                variant="base"
                fontSize={'md'}
                minW="225px"
              >
                See All Components
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
